<div class="checkout-page">

  <div class="checkout-container">

    <div class="checkout-card">

      <h1>
        Só mais um pouco!
      </h1>

      <p class="subtitle">
        Escolha como deseja pagar
      </p>

      <h3>
        Endereço da cobrança
      </h3>


      <div class="form-grid">

        <input
          type="text"
          placeholder="CEP"
          [(ngModel)]="cep"
          (blur)="buscarCep()"
        />

        <input
          type="text"
          placeholder="Logradouro"
          [(ngModel)]="endereco"
        />

        <input
          type="text"
          placeholder="Número"
          [(ngModel)]="numero"
        />

        <input
          type="text"
          placeholder="Complemento"
          [(ngModel)]="complemento"
        />

        <input
          type="text"
          placeholder="Bairro"
          [(ngModel)]="bairro"
        />

        <input
          type="text"
          placeholder="Cidade"
          [(ngModel)]="cidade"
        />

        <input
          type="text"
          placeholder="Estado"
          [(ngModel)]="estado"
        />

      </div>

      <h3 class="titulo-pagamento">
        Forma de Pagamento
      </h3>


      <div class="pagamentos">

        <button
          type="button"
          class="pagamento-option"
          [class.selecionado]="formaPagamento === 'CARTAO'"
          (click)="selecionarPagamento('CARTAO')"
        >

          <span class="radio">

            <span
              *ngIf="formaPagamento === 'CARTAO'"
            ></span>

          </span>

          <div>

            <strong>
              Cartão de crédito
            </strong>

            <small>
              Pague com cartão
            </small>

          </div>

        </button>


        <button
          type="button"
          class="pagamento-option"
          [class.selecionado]="formaPagamento === 'PIX'"
          (click)="selecionarPagamento('PIX')"
        >

          <span class="radio">

            <span
              *ngIf="formaPagamento === 'PIX'"
            ></span>

          </span>

          <div>

            <strong>
              PIX
            </strong>

            <small>
              Pagamento instantâneo
            </small>

          </div>

        </button>

      </div>

      <div class="actions">

        <button
          type="button"
          class="btn-voltar"
          (click)="voltar()"
        >
          Voltar
        </button>

        <button
          type="button"
          class="btn-continuar"
          (click)="continuar()"
        >
          Continuar
        </button>

      </div>

    </div>

    <div class="resumo-card">

      <div class="resumo-topo">

        <img
          [src]="dados?.quartoImagem"
        />

        <div>

          <h3>
            {{ dados?.quartoNome }}
          </h3>

          <p>
            {{ descricaoAcomodacao }}
          </p>

        </div>

      </div>


      <div class="resumo-linha">

        <strong>
          Datas
        </strong>

        <span>
      {{ formatarData(dados?.checkIn) }}
          -
          {{ formatarData(dados?.checkOut) }}
    </span>

      </div>


      <div class="resumo-linha">

        <strong>
          Hóspedes
        </strong>

        <span>
      {{ adultos }} adulto(s),
          {{ criancas }} criança(s)
      e
          {{ animais }} animal(is)
    </span>

      </div>


      <!-- ==============================
           CUPOM DE DESCONTO
           ============================== -->

      <div class="cupom-box">

        <label for="codigoCupom">
          Cupom de desconto
        </label>


        @if (!cupomAplicado) {

          <div class="cupom-input">

            <input
              id="codigoCupom"
              type="text"
              [(ngModel)]="codigoCupom"
              placeholder="Digite seu cupom"
              maxlength="50"
              [disabled]="aplicandoCupom"
              (keyup.enter)="aplicarCupom()"
            />


            <button
              type="button"
              (click)="aplicarCupom()"
              [disabled]="aplicandoCupom"
            >

              @if (aplicandoCupom) {

                Aplicando...

              } @else {

                Aplicar

              }

            </button>

          </div>

        } @else {

          <div class="cupom-aplicado">

            <div class="cupom-info">

          <span class="cupom-check">
            ✓
          </span>

              <div>

                <strong>
                  {{ codigoCupom }}
                </strong>

                <small>
                  Cupom aplicado com sucesso
                </small>

              </div>

            </div>


            <button
              type="button"
              class="remover-cupom"
              (click)="removerCupom()"
            >
              Remover
            </button>

          </div>

        }

      </div>


      <!-- ==============================
           VALORES
           ============================== -->

      @if (cupomAplicado) {

        <div class="resumo-linha">

          <strong>
            Subtotal
          </strong>

          <span>
        R$
            {{ valorOriginal | number:'1.2-2' }}
      </span>

        </div>


        <div class="resumo-linha desconto-linha">

          <strong>
            Desconto
          </strong>

          <span>
        - R$
            {{ valorDesconto | number:'1.2-2' }}
      </span>

        </div>

      }


      <div class="resumo-linha">

        <strong>
          Preço total
        </strong>

        <span class="valor">

      R$
          {{ valorTotal | number:'1.2-2' }}

    </span>

      </div>


    </div>


  </div>

</div>
